import {Component} from '@angular/core';
import {Tenant} from '../../../interfaces/tenant';
import {ActivatedRoute, Router} from '@angular/router';
import {Location} from '@angular/common';
import {GeneralFormComponent} from '../../general/form/generalForm.component';
import {TenantService} from '../../../services/tenant.service';
import {MessageService} from '../../../../shared/message.service';
import {QuestionService} from '../../../services/question.service';
import {QuestionControlService} from '../../../services/question-control.service';

/**
 * Tenant detail form.
 */
@Component({
  selector: 'qm-tenant-details',
  templateUrl: './tenant-details.component.html',
  styleUrls: ['./tenant-details.component.css']
})
export class TenantDetailsComponent extends GeneralFormComponent<Tenant> {

  selectedReadGroupsFromRest: string[] = [];
  selectedWriteGroupsFromRest: string[] = [];
  selectedUiGroupsFromRest: string[] = [];

  updatedReadRights: string[] = [];
  updatedWriteRights: string[] = [];
  updatedAdditionalRrights: string[] = [];

  constructor(
    route: ActivatedRoute,
    tenantService: TenantService,
    location: Location,
    messagesService: MessageService,
    router: Router,
    questionService: QuestionService,
    questionControlService: QuestionControlService,
  ) {
    super(route, tenantService, location, messagesService, router, questionService, questionControlService,
      {
        entityNameSingular: 'tenant',
        entityNamePlural: 'tenants',
        formUrl: 'tenant',
        listUrl: 'tenants',
        generalFormMetaName: 'tenant'
      });
  }

  /**
   * Fetches the entity from the rest by using fetchEntity function of super. If not new
   * then user right groups are taken set to local variable.
   */
  async fetchEntity(): Promise<void> {
    await super.fetchEntity();
    if (!this.isNew()) {
      const readRights: any[] = this.entity.licence['read_rights'];
      const writeRights: any[] = this.entity.licence['write_rights'];
      const additionalRrights: any[] = this.entity.licence['additional_rights'];

      this.selectedReadGroupsFromRest = readRights ? readRights : [];
      this.selectedWriteGroupsFromRest = writeRights ? writeRights : [];
      this.selectedUiGroupsFromRest = additionalRrights ? additionalRrights : [];

      this.updatedReadRights = [...this.selectedReadGroupsFromRest];
      this.updatedWriteRights = [...this.selectedWriteGroupsFromRest];
      this.updatedAdditionalRrights = [...this.selectedUiGroupsFromRest];
    }
  }

  /**
   * Sets values from form tenant to the tenant that is sent to rest.
   * @param {Tenant} tenant The tenant to which the values are set.
   * @param formEntity The form tenant from which the values are taken.
   */
  updateEntityValues(tenant: Tenant, formEntity: any): void {
    super.updateEntityValues(tenant, formEntity);
    if (!tenant.licence) {
      tenant.licence = {};
    }
    tenant.licence['read_rights'] = this.updatedReadRights;
    tenant.licence['write_rights'] = this.updatedWriteRights;
    tenant.licence['additional_rights'] = this.updatedAdditionalRrights;
  }

  /**
   * When read rights have been changed.
   * @param targets New read targets.
   */
  readGroupIdsChanged(targets: string[]): void {
    this.updatedReadRights = targets;
  }

  /**
   * When write rights have been changed.
   * @param targets New write targets.
   */
  writeGroupIdsChanged(targets: string[]): void {
    this.updatedWriteRights = targets;
  }


  /**
   * When ui rights have been changed.
   * @param targets New ui targets.
   */
  uiIdsChanged(targets: string[]): void {
    this.updatedAdditionalRrights = targets;
  }
}
